export type ManufacturerLogoSize = "mini" | "small" | "medium" | "large";

export const MANUFACTURER_LOGO_SIZE_MAP: Record<ManufacturerLogoSize, number> =
  {
    mini: 20,
    small: 24,
    medium: 32,
    large: 40,
  };

export const normalizeManufacturerToLogoName = (
  manufacturer: string | undefined | null,
): string | null => {
  if (!manufacturer || !manufacturer.trim()) {
    return null;
  }

  return manufacturer.trim().toLowerCase();
};
